// Test IDs for the audio-cue layer (Phase 07).
export const AUDIO = {
    modeToggle: 'audio-mode-toggle',       // wraps the 3-mode segmented control
    modeOff: 'audio-mode-off',
    modeBeeps: 'audio-mode-beeps',
    modeVoice: 'audio-mode-voice',
    restTargetInput: 'audio-rest-target-input',
    countdownDisplay: 'audio-countdown-display',
};
